let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1pxHe")).then(() => parcelRequire('1y3eu'));